import * as types from "./types";

const mutations = {
    [types.GET_INCOME_LIST](state, incomeList) {
        state.incomeList = incomeList;
    },
    [types.POST_INCOME](state, id) {
        state.incomeId = id;
    },
    [types.DELETE_INCOME](state, id) {
        state.incomeId = id;
    },
    [types.UPDATE_INCOME](state, id) {
        state.incomeId = id;
    },
    [types.LOADING_ITEM](state, loading) {
        state.loading = loading;
    }
};

export default mutations;